import { render, staticRenderFns } from "./BilletConfigList.vue?vue&type=template&id=eb97b96e&"
import script from "./BilletConfigList.vue?vue&type=script&lang=js&"
export * from "./BilletConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports